import { CreateCustomerSessionState } from './createCustomerSession.types'

const initialState: CreateCustomerSessionState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
